module.exports = __webpack_public_path__ + "img/0Q3A6453_L_Wood.cc9c33bb.jpg";